// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fZKCP","modalBody":"styles_modalBody__2DwQ9"};